import { Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { NavigationEntity, useIsSelected } from "hooks/useNavigationEntities";
import Link from "next/link";

const NavigationLinkItem = ({ entity }: { entity: NavigationEntity }) => {
  const isSelected = useIsSelected(entity);
  return (
    <Link href={entity.absolutePath ?? ""}>
      <Text
        fontSize={isSelected ? "lg" : "sm"}
        textDecoration={isSelected ? "underline" : "none"}
      >
        {entity.name}
      </Text>
    </Link>
  );
};

export default observer(NavigationLinkItem);
